// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__92Hra","content":"RecentSearches_content__32px4"};